(ns ui.view.page.view)

(defn centered
  [& children]
  (into [:div
         {:class "mx-auto p-2 max-w-[1024px] min-h-screen flex flex-col gap-4 text-base-light-text bg-base-light"}]
        children))


(defn full
  [& children]
  (into [:div
         {:class "min-h-screen mx-auto flex flex-col gap-2 relative text-base-light-text bg-base-light"}]
        children))

(defn full-no-page-scroll
  [& children]
  (into [:div
         {:class "min-h-screen min-w-full flex flex-col relative gap-2 bg-base-light"}]
        children))

(defn left-align
  []
  )

